/* ITA2-1590 — Save for later, cart page.
   Source of truth for the UI is the `it7sfl` localStorage list (instant, works when Swym is
   down — it initializes unreliably on this store, see it7-wishlist.js). For signed-in shoppers
   a Swym list is the durable, cross-device copy (see "Swym" below): every change is mirrored
   to it and, on load, the two are merged. Price and availability are always re-read from
   Shopify, never stored.
   Every action shows its pending state on the control that started it, and ends in a toast
   that says what happened (with Undo / View wishlist where that helps). */
(function () {
  var KEY = 'it7sfl';
  var root = document.getElementById('it7-sfl');
  if (!root) return;
  var T = root.dataset;
  var ul = root.querySelector('.it7-sfl-list');
  var toastEl = document.getElementById('it7-sfl-toast');

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function handleOf(du) { return (du || '').split('?')[0].split('/products/')[1] || ''; }
  function same(a, b) { return String(a.epi) === String(b.epi); }

  /* ── Swym: cross-device copy for SIGNED-IN shoppers ───────────────────
     A dedicated Swym list (lty "sfl", lname "it7-sfl") through the generic Lists API —
     Swym's SaveForLater module isn't loaded on this store, but createList / addToList /
     fetchListDetails / deleteFromList / deleteList work on our Premium plan and sync across
     browsers (Codex test, 2 Oct 2026). Guests stay local: a guest Swym list is per-device.
     On sign-in, items saved as a guest on this device are pushed up (merge both ways). */
  var LNAME = 'it7-sfl';
  var swat = null, lid = null, waiting = null;
  function prod(i) { return { epi: Number(i.epi), empi: Number(i.empi), du: i.du }; }
  function withList(fn) {
    if (!swat || !T.signedIn) return;
    if (lid) return fn(lid);
    if (waiting) return waiting.push(fn);
    waiting = [fn];
    function ready(id) { var q = waiting; waiting = null; lid = id || null; if (lid) q.forEach(function (f) { f(lid); }); }
    try {
      swat.fetchLists({ lty: 'sfl', errorFn: function () { ready(null); }, callbackFn: function (lists) {
        var l = (lists || []).filter(function (x) { return x && x.lname === LNAME; })[0];
        if (l) return ready(l.lid);
        /* ponytail: two tabs signing in at once could each create a list; we always read the first by name. */
        swat.createList({ lname: LNAME, lty: 'sfl' }, function (r) { ready(r && r.lid); }, function () { ready(null); });
      } });
    } catch (e) { ready(null); }
  }
  /* Removals not yet visible in Swym's list (not bound, call failed, or its ~5-min list cache):
     kept so the merge below can't resurrect them, replayed on bind, dropped only once a fetched
     remote list no longer has them. */
  var RMKEY = 'it7sflrm';
  function rmGet() { try { return JSON.parse(localStorage.getItem(RMKEY) || '{}'); } catch (e) { return {}; } }
  function rmSet(o) { try { localStorage.setItem(RMKEY, JSON.stringify(o)); } catch (e) {} }
  function rmDel(epi) { var rm = rmGet(); if (rm[epi]) { delete rm[epi]; rmSet(rm); } }
  /* `s` on a local item = Swym has confirmed it. A confirmed item that later disappears from
     the remote list was removed on another device, so the merge drops it instead of re-adding. */
  function markSynced(epi) { var list = load(); list.forEach(function (i) { if (String(i.epi) === String(epi)) i.s = 1; }); store(list); }
  function swymAdd(i) {
    rmDel(i.epi);
    withList(function (id) { try { swat.addToList(id, prod(i), function () { markSynced(i.epi); }, function () {}); } catch (e) {} });
  }
  function swymRemove(i) {
    if (!T.signedIn) return;
    var rm = rmGet(); rm[i.epi] = i; rmSet(rm);
    withList(function (id) { try { swat.deleteFromList(id, prod(i), function () {}, function () {}); } catch (e) {} });
  }
  function swymMerge() {
    withList(function (id) {
      try {
        swat.fetchListDetails({ lid: id }, function (r) {
          var remote = (r && r.items) || [], rm = rmGet();
          function inRemote(epi) { return remote.some(function (x) { return x && String(x.epi) === String(epi); }); }
          Object.keys(rm).forEach(function (epi) { if (!inRemote(epi)) delete rm[epi]; });
          rmSet(rm);
          var before = load(), list = [], push = [];
          before.forEach(function (i) {
            if (inRemote(i.epi)) list.push(Object.assign(i, { s: 1 }));
            else if (!i.s) { list.push(i); push.push(i); }   /* new here (or saved as a guest): push up */
            /* else: confirmed earlier, gone remotely → removed on another device: drop */
          });
          remote.forEach(function (x) {
            if (!x || !x.epi || rm[String(x.epi)] || list.some(function (i) { return String(i.epi) === String(x.epi); })) return;
            list.push({ epi: String(x.epi), empi: String(x.empi), du: x.du, qty: 1, s: 1 });
          });
          store(list);
          push.forEach(swymAdd);
          if (JSON.stringify(list.map(function (i) { return i.epi; })) !== JSON.stringify(before.map(function (i) { return i.epi; }))) render();
        }, function () {});
      } catch (e) {}
    });
  }
  function bindSwat(s) {
    if (swat || !s) return;
    swat = s;
    var rm = rmGet();
    Object.keys(rm).forEach(function (epi) { swymRemove(rm[epi]); });
    swymMerge();
  }
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(bindSwat);
  var tries = 0, poll = setInterval(function () {
    if (swat) return clearInterval(poll);
    if (window._swat) { clearInterval(poll); bindSwat(window._swat); } else if (++tries > 200) clearInterval(poll);
  }, 300);

  /* ── Formatting ─────────────────────────────────────────────────────── */
  /* Same price format as every other JS surface ($1,234 USD), via it7-fx.js when present. */
  function money(major, bare) {
    if (window.IT7FX) return bare ? IT7FX.formatBare(major) : IT7FX.format(major);
    return Math.round(major).toLocaleString('en-US');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  /* Card names match the grid: the product title minus its leading vendor. */
  function cleanTitle(t, v) { t = t || ''; return v && t.toLowerCase().indexOf(v.toLowerCase() + ' ') === 0 ? t.slice(v.length + 1) : t; }

  /* ── Feedback: pending buttons + toast ──────────────────────────────── */
  function busy(b, label) {
    if (!b) return;
    b.dataset.label = b.innerHTML;
    b.disabled = true;
    b.setAttribute('aria-busy', 'true');
    b.innerHTML = '<span class="it7-sfl-spin" aria-hidden="true"></span>' + esc(label);
  }
  function idle(b) {
    if (!b || !b.dataset.label) return;
    b.innerHTML = b.dataset.label;
    b.disabled = false;
    b.removeAttribute('aria-busy');
  }
  var toastTimer;
  function toast(msg, action) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.innerHTML = '<span class="it7-sfl-toast-msg">' + esc(msg) + '</span>' +
      (action ? (action.href ? '<a class="it7-sfl-toast-act" href="' + esc(action.href) + '">' + esc(action.label) + '</a>'
                             : '<button type="button" class="it7-sfl-toast-act">' + esc(action.label) + '</button>') : '');
    if (action && action.fn) toastEl.querySelector('button').addEventListener('click', function () { hideToast(); action.fn(); });
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    toastTimer = setTimeout(hideToast, 8000);
  }
  /* Undo must stay reachable: the toast holds while hovered or focused (WCAG 2.2.1). */
  if (toastEl) {
    ['mouseenter', 'focusin'].forEach(function (ev) { toastEl.addEventListener(ev, function () { clearTimeout(toastTimer); }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { toastEl.addEventListener(ev, function () { clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 4000); }); });
  }
  /* Focus follows the change so keyboard users aren't dropped on <body>. */
  function focusList() {
    /* The list hides when its last card goes; fall back to the bag's page title. */
    var h = load().length ? document.getElementById('it7-sfl-h') : document.querySelector('.main-page-title');
    if (!h) return;
    if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
    h.focus({ preventScroll: true });
  }
  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.remove('is-on');
    setTimeout(function () { if (!toastEl.classList.contains('is-on')) toastEl.hidden = true; }, 220);
  }
  function bagCount(n) { document.dispatchEvent(new CustomEvent('it7:cart-updated', { detail: typeof n === 'number' ? { item_count: n } : {} })); }

  /* Resolves when cart.js finishes re-rendering after updateQuantity (it publishes on success only). */
  function nextCartUpdate(ms) {
    return new Promise(function (res, rej) {
      if (typeof subscribe !== 'function') return rej();
      var t, un = subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (!ev || ev.source !== 'cart-items') return;
        clearTimeout(t); un(); res();
      });
      t = setTimeout(function () { un(); rej(); }, ms);
    });
  }

  /* ── Motion: nothing jumps. The saved list and the bag change height smoothly, surviving
     items slide to their new place (FLIP), the list opens/closes instead of popping. ─────── */
  var EASE = 'cubic-bezier(.23,1,.32,1)', MS = 300;
  function still() { return !Element.prototype.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  /* Apply `change` to the DOM, then animate `el` from its old height to its new one and slide
     the items matched by `sel` (identified by `key`) from where they were. */
  function glide(el, change, sel, key, enter) {
    if (still()) return change();
    var h0 = el.getBoundingClientRect().height, first = {};
    el.querySelectorAll(sel).forEach(function (n) { var k = key(n); if (k) first[k] = n.getBoundingClientRect(); });
    change();
    var h1 = el.getBoundingClientRect().height;
    el.querySelectorAll(sel).forEach(function (n) {
      var f = first[key(n)];
      if (!f) { if (enter) n.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'none'] }, { duration: MS, easing: EASE }); return; }
      var l = n.getBoundingClientRect(), dx = f.left - l.left, dy = f.top - l.top;
      if (dx || dy) n.animate({ transform: ['translate(' + dx + 'px,' + dy + 'px)', 'none'] }, { duration: MS, easing: EASE });
    });
    if (Math.abs(h1 - h0) < 1) return;
    el.style.overflow = 'clip';
    var a = el.animate({ height: [h0 + 'px', h1 + 'px'] }, { duration: MS, easing: EASE });
    a.onfinish = a.oncancel = function () { el.style.overflow = ''; };
  }
  var cardKey = function (n) { return n.dataset.epi; };
  var lineKey = function (n) { var b = n.querySelector('[data-epi]'); return b && b.dataset.epi; };
  /* Open/close the whole "Saved for later" block (height + its vertical padding + fade). */
  var rootAnim = null;
  function toggleRoot(show, change) {
    if (rootAnim) { rootAnim.cancel(); rootAnim = null; }
    if (still()) { root.hidden = !show; change(); return; }
    var cs, h;
    root.style.overflow = 'clip';
    if (show) {
      root.hidden = false; change();
      cs = getComputedStyle(root); h = root.getBoundingClientRect().height;
      rootAnim = root.animate({ height: ['0px', h + 'px'], paddingTop: ['0px', cs.paddingTop], paddingBottom: ['0px', cs.paddingBottom], opacity: [0, 1] }, { duration: MS, easing: EASE });
      rootAnim.onfinish = rootAnim.oncancel = function () { root.style.overflow = ''; rootAnim = null; };
    } else {
      cs = getComputedStyle(root); h = root.getBoundingClientRect().height;
      rootAnim = root.animate({ height: [h + 'px', '0px'], paddingTop: [cs.paddingTop, '0px'], paddingBottom: [cs.paddingBottom, '0px'], opacity: [1, 0] }, { duration: MS, easing: EASE });
      rootAnim.onfinish = function () { root.hidden = true; root.style.overflow = ''; rootAnim = null; change(); };
      rootAnim.oncancel = function () { root.style.overflow = ''; };
    }
  }
  /* A saved bag line folds away before the bag re-renders without it. */
  function foldLine(line) {
    if (!line || still()) return null;
    var cs = getComputedStyle(line);
    line.style.overflow = 'clip';
    return line.animate({ height: [line.getBoundingClientRect().height + 'px', '0px'], paddingTop: [cs.paddingTop, '0px'], paddingBottom: [cs.paddingBottom, '0px'], opacity: [1, 0] }, { duration: MS, easing: EASE, fill: 'forwards' });
  }

  /* Re-render the bag in place after an add (same sections + sticky-bar sync cart.js does on a
     change). From an empty bag the phone sticky bar no longer exists, so reload instead. */
  function refreshCart() {
    var ci = document.querySelector('cart-items');
    if (!ci || !ci.getSectionsToRender || !ci.getSectionInnerHTML || ci.classList.contains('is-empty')) { location.reload(); return new Promise(function () {}); }
    var secs = ci.getSectionsToRender();
    return fetch(location.pathname + '?sections=' + secs.map(function (s) { return s.section; }).join(','))
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (map) {
        secs.forEach(function (s) {
          var el = document.getElementById(s.id);
          if (!el || !map[s.section]) return;
          var put = function () { (el.querySelector(s.selector) || el).innerHTML = ci.getSectionInnerHTML(map[s.section], s.selector); };
          if (s.id === 'main-cart-items') glide(el, put, '.cart-item', lineKey, true); else put();
        });
        var footer = document.getElementById('main-cart-footer');
        var fresh = footer && map[footer.dataset.id] && new DOMParser().parseFromString(map[footer.dataset.id], 'text/html').querySelector('.it7-cart-sticky .it7-cs-value');
        var live = document.querySelector('.it7-cart-sticky .it7-cs-value');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var empty = cart.item_count === 0, f = document.getElementById('main-cart-footer');
        ci.classList.toggle('is-empty', empty);
        if (f) f.classList.toggle('is-empty', empty);
        bagCount(cart.item_count);
      });
  }

  /* ── Save (from a cart line) ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-it7-sfl-save]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var ci = b.closest('cart-items');
    if (!ci || !ci.updateQuantity) return;
    var item = { epi: b.dataset.epi, empi: b.dataset.empi, du: location.origin + b.dataset.url, qty: parseInt(b.dataset.qty, 10) || 1 };
    var line = b.closest('.cart-item');
    busy(b, T.saving);
    if (line) line.classList.add('it7-sfl-leaving');
    var fold = foldLine(line);
    nextCartUpdate(10000).then(function () {
      var list = load().filter(function (i) { return !same(i, item); });
      list.unshift(item);
      store(list);
      swymAdd(item);
      render(item.epi);
      bagCount();
      focusList();
      toast(T.savedMsg, { label: T.undo, fn: function () { moveToBag(item, null); } });
    }, function () {
      if (fold) fold.cancel();
      if (line) { line.style.overflow = ''; line.classList.remove('it7-sfl-leaving'); }
      idle(b);
      toast(T.errorMsg);
    });
    var go = function () { ci.updateQuantity(b.dataset.index, 0); };
    if (fold) fold.onfinish = go; else go();
  });

  /* ── Saved list actions ─────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sfl-act]');
    if (!b || b.disabled) return;
    var li = b.closest('[data-epi]');
    var item = load().filter(function (i) { return String(i.epi) === li.dataset.epi; })[0];
    if (!item) return;
    var act = b.dataset.sflAct;
    if (act === 'bag') return moveToBag(item, b);
    if (act === 'wish') {
      if (!window.it7WishAdd) return toast(T.errorMsg); /* bridge (it7-wishlist.js) owns storage, Swym sync, header count */
      window.it7WishAdd(String(item.empi), String(item.epi), item.du);
      leave(li, item);
      toast(T.wishedMsg, { label: T.viewWish, href: T.wishUrl });
      return;
    }
    if (act === 'remove') {
      var at = load().findIndex(function (i) { return same(i, item); });
      leave(li, item);
      toast(T.removedMsg, { label: T.undo, fn: function () {
        var list = load().filter(function (i) { return !same(i, item); });
        delete item.s; /* re-added: unconfirmed until Swym takes it again */
        list.splice(Math.max(0, at), 0, item);
        store(list); swymAdd(item); render(item.epi);
      } });
    }
  });

  function moveToBag(item, b) {
    busy(b, T.adding);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(item.epi), quantity: item.qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        /* It's in the bag now: take it off the saved list BEFORE refreshCart, which reloads the
           page when the bag was empty (otherwise the reload would show it in both places). */
        var li = ul.querySelector('[data-epi="' + String(item.epi) + '"]');
        if (li) li.classList.add('is-leaving');
        store(load().filter(function (i) { return !same(i, item); }));
        swymRemove(item);
        return refreshCart().catch(function () { location.reload(); return new Promise(function () {}); });
      })
      .then(function () {
        render();
        focusList();
        toast(T.bagMsg);
      })
      .catch(function () { idle(b); toast(T.errorMsg); });
  }

  /* The card fades out, then the list closes the gap. */
  function leave(li, item) {
    li.classList.add('is-leaving');
    setTimeout(function () { drop(item); focusList(); }, still() ? 0 : 200);
  }
  function drop(item) {
    store(load().filter(function (i) { return !same(i, item); }));
    swymRemove(item);
    render();
  }

  /* ── Render (current price + availability from Shopify) ─────────────── */
  var cache = {};
  function product(handle) {
    if (cache[handle]) return cache[handle];
    var js = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    var fx = window.IT7FX && IT7FX.presentment ? IT7FX.quote(handle) : Promise.resolve(null);
    return (cache[handle] = Promise.all([js, fx]).then(function (r) { if (r[0]) r[0].fx = r[1]; return r[0]; }));
  }

  function card(item, p, fresh) {
    var v = p && p.variants.filter(function (x) { return String(x.id) === String(item.epi); })[0];
    var url = item.du ? item.du.replace(location.origin, '') : '#';
    var img = (v && v.featured_image && v.featured_image.src) || (p && p.featured_image) || '';
    var state = !p || !v ? 'gone' : v.available ? 'ok' : 'size-out';
    var status = state === 'ok' ? '' : state === 'size-out' ? T.sizeOut : T.gone;
    var opts = v && v.title && v.title !== 'Default Title' ? v.title : '';
    if (item.qty > 1) opts = (opts ? opts + ' · ' : '') + T.qty + ' ' + item.qty;
    /* Markets price (it7-fx.js) when the market isn't the shop currency, else the variant's. */
    var now = v && (p.fx && p.fx.price ? p.fx.price : v.price / 100);
    var was = v && (p.fx && p.fx.price ? p.fx.compareAt : v.compare_at_price / 100);
    var sale = v && was > now;
    var price = v ? '<span class="now' + (sale ? ' is-sale' : '') + '">' + money(now) + '</span>' + (sale ? '<s>' + money(was, true) + '</s>' : '') : '';
    var primary = state === 'ok'
      ? '<button type="button" class="it7-sfl-primary" data-sfl-act="bag">' + esc(T.moveBag) + '</button>'
      : state === 'size-out' ? '<a class="it7-sfl-primary is-outline" href="' + esc(url) + '">' + esc(T.chooseSize) + '</a>' : '';
    var name = p ? cleanTitle(p.title, p.vendor) : handleOf(item.du);
    return '<li class="it7-sfl-card' + (fresh ? ' is-new' : '') + '" data-epi="' + esc(item.epi) + '" data-state="' + state + '">' +
      '<div class="it7-sfl-im">' +
        '<a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=480" alt="" loading="lazy" width="240" height="300">' : '') + '</a>' +
        '<button type="button" class="it7-sfl-x" data-sfl-act="remove" aria-label="' + esc(T.remove + ': ' + name) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg></button>' +
      '</div>' +
      '<div class="it7-sfl-meta">' +
        (p ? '<span class="it7-sfl-b">' + esc(p.vendor) + '</span>' : '') +
        '<a class="it7-sfl-n" href="' + esc(url) + '">' + esc(name) + '</a>' +
        (opts ? '<span class="it7-sfl-opt">' + esc(opts) + '</span>' : '') +
        '<span class="it7-sfl-pr">' + price + '</span>' +
        (status ? '<span class="it7-sfl-status">' + esc(status) + '</span>' : '') +
      '</div>' +
      '<div class="it7-sfl-acts">' + primary +
        '<button type="button" class="it7-sfl-link" data-sfl-act="wish"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 13.5S2.5 10.2 2.5 6.1A2.9 2.9 0 0 1 8 4.6a2.9 2.9 0 0 1 5.5 1.5c0 4.1-5.5 7.4-5.5 7.4z"/></svg>' + esc(T.moveWish) + '</button>' +
      '</div></li>';
  }

  function skeleton(n) {
    var one = '<li class="it7-sfl-card is-skel" aria-hidden="true"><div class="it7-sfl-im"></div><div class="it7-sfl-meta"><span class="sk sk-b"></span><span class="sk sk-n"></span><span class="sk sk-p"></span></div></li>';
    return new Array(n + 1).join(one);
  }

  var seq = 0, painted = false;
  function render(freshEpi) {
    var list = load(), mine = ++seq, first = !painted;
    painted = true;
    root.querySelector('[data-sfl-count]').textContent = list.length;
    if (!list.length) {
      if (root.hidden && !rootAnim) return;
      if (first) { root.hidden = true; ul.innerHTML = ''; return; }
      return toggleRoot(false, function () { ul.innerHTML = ''; });
    }
    var ready = list.every(function (i) { return cache[handleOf(i.du)]; });
    /* First paint: show skeletons at once (no motion on page load). */
    if (first && !ready) { root.hidden = false; ul.innerHTML = skeleton(Math.min(list.length, 4)); }
    Promise.all(list.map(function (i) { return product(handleOf(i.du)); })).then(function (ps) {
      if (mine !== seq) return; /* a newer render won */
      var paint = function () { ul.innerHTML = list.map(function (i, k) { return card(i, ps[k], String(i.epi) === String(freshEpi)); }).join(''); };
      if (first) { root.hidden = false; return paint(); }
      if (root.hidden || rootAnim) return toggleRoot(true, paint);
      glide(root, paint, 'li[data-epi]', cardKey);
    });
  }

  render();
})();
